import { render } from "./TestPCShowNoResults.vue?vue&type=template&id=7ee833ff"
import script from "./TestPCShowNoResults.vue?vue&type=script&lang=js"
export * from "./TestPCShowNoResults.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__